import React from "react";
import "../css/Footer.css";
import { useRestaurante } from "../context/RestauranteContext";
import { useUser } from "../context/UserContext";
import { useCarrinho } from "../context/CarrinhoContext";
import { FaHome, FaClipboardList, FaShoppingCart } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const { user } = useUser();
  const { restauranteId, setRestauranteId } = useRestaurante();
  const { calcularQuantidadeTotal, restauranteCarrinho } = useCarrinho();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // "Cardápio" só aparece quando a tela atual é de um restaurante: o cardápio dele, as telas
  // /restaurantes/:id/... ou o carrinho (do restaurante dos itens). Na lista de restaurantes e
  // nas demais telas não há restaurante selecionado, mesmo que um tenha sido aberto antes.
  const restauranteCardapio = (() => {
    const doCardapio = pathname.match(/^\/(\d+)\/cardapio/);
    if (doCardapio) return doCardapio[1];
    const daRota = pathname.match(/^\/restaurantes\/(\d+)(\/|$)/);
    if (daRota) return daRota[1];
    if (pathname === "/carrinho") return restauranteCarrinho || restauranteId;
    return null;
  })();
  const quantidadeCarrinho = calcularQuantidadeTotal();

  const handleListarRestaurantes = () => {
    navigate("/restaurantes");
    setRestauranteId(null);
  };

  const ativo = (condicao) => (condicao ? "footer-item ativo" : "footer-item");

  return (
    <footer className={pathname.startsWith("/admin") ? "footer" : "footer tema-cliente"}>
      <button
        type="button"
        className={ativo(pathname === "/restaurantes")}
        onClick={handleListarRestaurantes}
      >
        <FaClipboardList aria-hidden="true" />
        <span>Restaurantes</span>
      </button>
      {restauranteCardapio && (
        <Link
          to={"/" + restauranteCardapio + "/cardapio"}
          className={ativo(pathname.endsWith("/cardapio"))}
        >
          <FaHome aria-hidden="true" />
          <span>Cardápio</span>
        </Link>
      )}
      {!user && (
        <Link
          to="/carrinho"
          className={ativo(pathname === "/carrinho")}
          aria-label={`Carrinho com ${quantidadeCarrinho} ${quantidadeCarrinho === 1 ? "item" : "itens"}`}
        >
          <span className="footer-icone">
            <FaShoppingCart aria-hidden="true" />
            {quantidadeCarrinho > 0 && <span className="carrinho-count">{quantidadeCarrinho}</span>}
          </span>
          <span>Carrinho</span>
        </Link>
      )}
    </footer>
  );
};

export default Footer;
